import axios, {AxiosError} from "axios";
import {setMockResponses} from "./apiMock";

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_ROOT,
    headers: {
        "X-Requested-With": "XMLHttpRequest",
    },
});

if (process.env.NODE_ENV === "development") {
    import("./axios-logger").then((mod) => {
        mod.use(instance);
    });
}

if (process.env.REACT_APP_MOCK_API === "true") {
    setMockResponses(
        instance,
        process.env.REACT_APP_MOCK_TIMEOUT_MS
            ? parseInt(process.env.REACT_APP_MOCK_TIMEOUT_MS)
            : 500,
    );
}

export function setupAuthInterceptor(interceptor: (err: AxiosError) => Promise<never>) {
    instance.interceptors.response.use(undefined, interceptor);
}

export default instance;
